export default __webpack_public_path__ + "static/media/f21799fa7a8087412ebed9e5e96e37411581603325974.6bc33cf6.webp";